// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { HgFrontend } from "../io/hyperify/frontend/HgFrontend";
import { GeoIpService } from "./GeoIpService";
import { BannerService } from "./BannerService";

export class AppInitializer {

    public static initialize () {
        HgFrontend.initialize();
        GeoIpService.initialize();
        BannerService.initialize();
    }

}
